import React from 'react';
import { get } from 'lodash';
import { submit } from 'redux-form';
import PropTypes from 'prop-types';
import ModalManager from '../elements-modal/modal-manager-v2';
import { CreateAddOnModal } from '../app-bookings-custom/modals/create-add-on-modal';
import EditAddOnModal from '../app-bookings-custom/modals/edit-add-on-modal';
import DeleteAddonModal from '../app-bookings-custom/modals/DeleteAddonModal';
import { CREATE_ITEM_FORM } from '../app-main/components/reduxForms/constants/formNames';

const ManageAddonsModal = (props) => {
  const {
    toggleModal,
    deleteItem,
    modal,
    isFetchingItem, // Need to pass this props
    isSubmitting, // Need to pass this props
    currency,
    spaceId,
    dispatch = null,
    accessToken = ''
  } = props;

  return (
    <ModalManager
      whichModal={get(modal, 'modalId')}
      toggleModal={toggleModal}
    >
      <CreateAddOnModal
        id="createAddOnModal"
        currency={currency}
        isSubmitting={isSubmitting}
        spaceId={spaceId}
        initialValues={{ visible_on_listing: 'true' }}
        createItem={() => dispatch(submit(CREATE_ITEM_FORM))}
        accessToken={accessToken}
        dispatch={dispatch}
        fromManageAddons
      />

      <EditAddOnModal
        id="editAddOnModal"
        currency={currency}
        isFetchingItem={isFetchingItem}
        isSubmitting={isSubmitting}
        spaceId={spaceId}
        createItem={() => dispatch(submit(CREATE_ITEM_FORM))}
        deleteItem={deleteItem}
        accessToken={accessToken}
        dispatch={dispatch}
        fromManageAddons
      />

      <DeleteAddonModal
        id="deleteAddOnModal"
        toggleModal={toggleModal}
        deleteItem={deleteItem}
      />
    </ModalManager>
  );
};

ManageAddonsModal.propTypes = {
  toggleModal: PropTypes.func,
  deleteItem: PropTypes.func,
  isSubmitting: PropTypes.bool,
  isFetchingItem: PropTypes.bool,
  currency: PropTypes.string,
  spaceId: PropTypes.string,
  modal: PropTypes.object,
  dispatch: PropTypes.func,
  accessToken: PropTypes.string
};

export default ManageAddonsModal;
